// Utility functions for Recipe Basket

export function loadIngredientCache() {
  try {
    const raw = localStorage.getItem('ingredientCache');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveIngredientCache(cache) {
  try {
    localStorage.setItem('ingredientCache', JSON.stringify(cache));
  } catch {}
}

export function levenshtein(a, b) {
  const an = a ? a.length : 0;
  const bn = b ? b.length : 0;
  if (an === 0) return bn;
  if (bn === 0) return an;
  const matrix = [];
  for (let i = 0; i <= bn; ++i) matrix[i] = [i];
  for (let j = 0; j <= an; ++j) matrix[0][j] = j;
  for (let i = 1; i <= bn; ++i) {
    for (let j = 1; j <= an; ++j) {
      matrix[i][j] = b.charAt(i - 1) === a.charAt(j - 1)
        ? matrix[i - 1][j - 1]
        : Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
    }
  }
  return matrix[bn][an];
}
